import { BaseModel } from "./base-model.model";

export class Item extends BaseModel {
    name!: string;
    description!: string;
}